export default __webpack_public_path__ + "static/media/preview.76ad2b4c.svg";